export default {
  spinner_default_label: "Buscando os dados, aguade.. ",
  search: "Pesquisar",
};
